import React from 'react';
import './SponsorsGrid.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const SponsorsGrid = ({ sponsorLogos }) => {
  return (
    <section className="SponsorsGridSection">
    <div className="container">
      <div className="sponsorsGridContainer">
        {sponsorLogos.map((logo, index) => (
          <div key={index} className="gridItem">
            <img src={logo} alt={`Sponsor ${index + 1}`} className="gridLogo" />
          </div>
        ))}
      </div>
    </div>
    </section>
  );
};

export default SponsorsGrid; 